import React from 'react';
import { hubPlan, redirects } from '../../data/architecture';
const actionStyles = {
  Keep: 'bg-opal text-ink',
  Widen: 'bg-foam text-ink',
  Fold: 'bg-peach text-ink'
};
export function HubConsolidation() {
  return <section aria-labelledby="hubs-plan-h" className="bg-paper" data-id="element-229" data-mp="3q2vyulvnbph3">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-230" data-mp="3v0e2bwqw9chp">
        <p className="label text-olive" data-id="element-231" data-mp="3v2ibat3nh1ou">Step one · Ten categories become seven</p>
        <h2 id="hubs-plan-h" className="mt-6 max-w-3xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-232" data-mp="mlnhe34tyrmw">
          What happens to every page you’ve already built
        </h2>
        <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-muted" data-id="element-233" data-mp="hu5fncuzgn0v">
          Nothing gets deleted and nothing loses its ranking. Four thin
          categories become child pages under a stronger parent, with a 301 so
          the traffic follows them.
        </p>

        <div className="mt-16 overflow-x-auto" data-id="element-234" data-mp="1acj4imyccynt">
          <table className="w-full min-w-[860px] border-collapse text-left" data-id="element-235" data-mp="ou0ievdbzf34">
            <caption className="sr-only" data-id="element-236" data-mp="ktgpk3zsixms">
              Each existing category page, whether it is kept, widened or
              folded, and where it ends up
            </caption>
            <thead data-id="element-237" data-mp="ymg0rtsji5oj">
              <tr className="border-y border-ink/20" data-id="element-238" data-mp="ttd7lmrocy8v">
                {['Current URL', 'Views', 'Action', 'Becomes', 'Why'].map(h => <th key={h} scope="col" className="label py-4 pr-8 text-muted" data-id="element-239" data-mp="18h7zx21rt0lf">
                    {h}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-240" data-mp="1hiel3ofd6zl0">
              {hubPlan.map(row => <tr key={row.current} className="border-b border-line align-top" data-id="element-241" data-mp="1ckczowuguo6d">
                  <th scope="row" className="max-w-[260px] py-6 pr-8 text-[13px] font-400 leading-relaxed text-ink" data-id="element-242" data-mp="1ciju7kvla9zy">
                    {row.current}
                  </th>
                  <td className="py-6 pr-8 text-[14px] text-muted" data-id="element-243" data-mp="1i94k6rxfrjrn">
                    {row.views ?? '—'}
                  </td>
                  <td className="py-6 pr-8" data-id="element-244" data-mp="1n8haxnrfhazi">
                    <span className={`label inline-block px-3 py-1.5 ${actionStyles[row.action]}`} data-id="element-245" data-mp="1s6sjlv5zlfg5">
                      {row.action}
                    </span>
                  </td>
                  <td className="py-6 pr-8 font-display text-[20px] font-400 leading-snug text-ink" data-id="element-246" data-mp="2188tm1sw3fju">
                    {row.becomes}
                  </td>
                  <td className="max-w-[340px] py-6 pr-8 text-[14px] leading-[1.7] text-muted" data-id="element-247" data-mp="2647al4bw1va8">
                    {row.why}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-16 border-t border-line pt-12" data-id="element-248" data-mp="2jygojwmfqzoy">
          <h3 className="font-display text-[28px] font-300 text-ink" data-id="element-249" data-mp="2jvvptghfozvf">
            Set these four redirects first
          </h3>
          <p className="mt-3 max-w-prose text-[14.5px] leading-[1.8] text-muted" data-id="element-250" data-mp="d9g231gbn634">
            Settings → Advanced → URL Mappings. One per line, before you
            unpublish anything.
          </p>
          <div className="mt-8 max-w-3xl space-y-2 bg-white px-7 py-7" data-id="element-251" data-mp="48hyuldpj2ll">
            {redirects.map(([from, to]) => <p key={from} className="break-all font-sans text-[12.5px] leading-relaxed text-ink/80" data-id="element-252" data-mp="3vgcn6s2sjeo7">
                {from} <span className="text-olive" data-id="element-253" data-mp="vyw824arzqqx">-&gt;</span> {to}{' '}
                <span className="text-muted" data-id="element-254" data-mp="ry2jd8pie7wz">301</span>
              </p>)}
          </div>
        </div>
      </div>
    </section>;
}